import { useEffect, useState } from 'react';
var ViewportOptions;
(function (ViewportOptions) {
    ViewportOptions["MOBILE"] = "mobile";
    ViewportOptions["TABLET"] = "tablet";
    ViewportOptions["SMALL_DESKTOP"] = "small-desktop";
    ViewportOptions["DESKTOP"] = "desktop";
})(ViewportOptions || (ViewportOptions = {}));
var getViewPort = function (width) {
    switch (true) {
        case width <= 576:
            return ViewportOptions.MOBILE;
        case width <= 768:
            return ViewportOptions.TABLET;
        case width <= 1024:
            return ViewportOptions.SMALL_DESKTOP;
        default:
            return ViewportOptions.DESKTOP;
    }
};
export default function useViewport() {
    var _a = useState(getViewPort(window.innerWidth)), viewport = _a[0], setViewport = _a[1];
    useEffect(function () {
        var handleWindowResize = function () {
            setViewport(getViewPort(window.innerWidth));
        };
        window.addEventListener('resize', handleWindowResize);
        return function () {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    return {
        isMobile: viewport === ViewportOptions.MOBILE,
        isTablet: viewport === ViewportOptions.TABLET,
        isSmallDesktop: viewport === ViewportOptions.SMALL_DESKTOP,
        isDesktop: viewport === ViewportOptions.DESKTOP
    };
}
